import { Navigate, Route, Routes} from 'react-router-dom';
import React from 'react';
import Dashboard from './dashboard/dashboard';
import ProfileUser from './dashboard/user/profileUser';
import ChangePasswordUser from './dashboard/user/changePasswordUser';
import ChangeProfileUser from './dashboard/user/changeProfileUser';
import ScoringUser from './dashboard/score/scoringUser';
import RedeemVoucher from './dashboard/redeem/redeemVoucher';
import BillList from './dashboard/bill/BillList';
import Login from './login/login';
import Signup from './login/signup';
import ForgetPassword from './login/forgetPassword';
import ELSACourse from './dashboard/course/ELSACourse';
import Page404 from './404/Page404'
import Oxford from './dashboard/course/Oxford';
import HarperCollins from './dashboard/course/HarperCollins';
import UpgradePackage from './dashboard/course/UpgradePackage';
import IELTS from './dashboard/course/Ielts';
import UniversalSignin from './login/universalSignin';

const AppRoutes: React.FC = () => {
  const isLoggedIn: boolean = localStorage.getItem('sessionToken') !== null;
  return (
    <Routes>
      <Route path="/" element={<Dashboard />}>
        <Route index element={<ProfileUser />} />
        <Route path="/elsascore" element={<ScoringUser />} />
        <Route path="/updateprofile" element={<ChangeProfileUser />} />
        <Route path="/changepassword" element={<ChangePasswordUser />} />
        <Route path="/redeem" element={<RedeemVoucher />} />
        <Route path="/bill" element={<BillList />} />
        <Route path="/course" element={<ELSACourse />}>
          <Route path="elsa-oxford" element={<Oxford />} />
          <Route path="harper-collins" element={<HarperCollins />} />
          <Route path="ielts" element={<IELTS />} />
        </Route>
        <Route path="/elsa-premium" element={<UpgradePackage />} />
        <Route
          path="/elsa-pro"
          element={<UpgradePackage upgradeType="elsa_speak" />}
        />
        <Route
          path="/elsa-professional"
          element={<UpgradePackage upgradeType="professional" />}
        />
        <Route path="/bill" element={<BillList />} />
      </Route>
      <Route path="/signup" element={isLoggedIn? <Navigate to='/'/> : <Signup />} />
      <Route path="/login" element={isLoggedIn? <Navigate to='/'/> : <Login />} />
      <Route path="/forgetpassword" element={isLoggedIn? <Navigate to='/'/> : <ForgetPassword />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default AppRoutes;
